/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

const About = () => {
  return (
    <div className="pt-1 pb-3 container-fluid">
      <h1 className="fs-4 pb-3">About</h1>
      <p>
        {/* This is a comment explaining the purpose of this paragraph */}
        This simulation tool replicates some of the functionality of Karsten (Big Ern) Jeske&apos;s
        Safe Withdrawal Rate simulation Google Sheet. For more information on this, see{" "}
        <a href="https://earlyretirementnow.com/2018/08/29/google-sheet-updates-swr-series-part-28/">
          Part 28 of Karsten&apos;s SWR Series
        </a>
        .
      </p>
      <p>
        Briefly, the tool uses monthly return data from 1/1871 to 9/2024 to simulate retirements
        that share your provided parameter values. Retirements starting at the beginning of each
        month between 1871 and 2015, at most, are simulated. Aggregate statistics for the
        retirements are then reported. For instance, the proportion of retirements that have less
        than your provided target at their ends is reported as the failure rate.{" "}
        <a href="https://earlyretirementnow.com/2017/02/01/the-ultimate-guide-to-safe-withdrawal-rates-part-8-technical-appendix/">
          Part 8 of the SWR Series
        </a>{" "}
        discusses the underlying math.
      </p>
      <p>
        The tool is still under construction, and we will add more features over time. If you have
        questions or suggestions, please get in touch with us at{" "}
        <a href="mailto:support&#64;saferetirementspending&#46;com">
          support&#64;saferetirementspending&#46;com
        </a>
        .
      </p>
    </div>
  )
}

export default About
